import { Pagination, theme } from 'components';
import * as React from 'react';
import styled from 'styled-components';
import { useShowingsCalendarContext } from '../../ShowingsCalendarContext';
import { PAGE_SIZE } from '../constants';

interface PaginationProps {
  count?: number;
}

const ShowingCalendarPagination: React.FC<PaginationProps> = ({ count }) => {
  const { page, setPage, totalShowingsCount } = useShowingsCalendarContext();

  const handlePageChange = (pageNumber: number) => {
    setPage(pageNumber - 1);
  };

  return (
    <StyledPagination
      current={page + 1}
      onChange={handlePageChange}
      total={totalShowingsCount}
      pageSize={PAGE_SIZE}
      showSizeChanger={false}
      responsive
    />
  );
};

export default ShowingCalendarPagination;

export const StyledPagination = styled(Pagination)`
  border-top: 1px solid ${theme.gray3};
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
`;
